interface IExitDoor {
  width?: number;
  height?: number;
}
export const ExitDoor = ({ width, height }: IExitDoor) => (
  <svg
    width={width || '21'}
    height={height || '20'}
    viewBox='0 0 21 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M3.83398 9.5C3.55784 9.5 3.33398 9.72386 3.33398 10C3.33398 10.2761 3.55784 10.5 3.83398 10.5L3.83398 9.5ZM13.1673 10L13.4927 10.3796C13.6035 10.2846 13.6673 10.146 13.6673 10C13.6673 9.85404 13.6035 9.71536 13.4927 9.62037L13.1673 10ZM11.1594 7.62037C10.9497 7.44066 10.6341 7.46494 10.4544 7.6746C10.2746 7.88427 10.2989 8.19992 10.5086 8.37963L11.1594 7.62037ZM10.5086 11.6204C10.2989 11.8001 10.2746 12.1157 10.4544 12.3254C10.6341 12.5351 10.9497 12.5593 11.1594 12.3796L10.5086 11.6204ZM3.83398 10.5L13.1673 10.5L13.1673 9.5L3.83398 9.5L3.83398 10.5ZM13.4927 9.62037L11.1594 7.62037L10.5086 8.37963L12.8419 10.3796L13.4927 9.62037ZM12.8419 9.62037L10.5086 11.6204L11.1594 12.3796L13.4927 10.3796L12.8419 9.62037Z'
      fill='#1552E8'
    />
    <path
      d='M8.50098 6.66146C8.50905 5.21144 8.57335 4.42617 9.0856 3.91391C9.67139 3.32812 10.6142 3.32812 12.4998 3.32812L13.1665 3.32812C15.0521 3.32812 15.9949 3.32812 16.5807 3.91391C17.1665 4.4997 17.1665 5.44251 17.1665 7.32812L17.1665 12.6615C17.1665 14.5471 17.1665 15.4899 16.5807 16.0757C15.9949 16.6615 15.0521 16.6615 13.1665 16.6615H12.4998C10.6142 16.6615 9.67139 16.6615 9.0856 16.0757C8.57335 15.5634 8.50905 14.7781 8.50098 13.3281'
      stroke='#1552E8'
      strokeLinecap='round'
    />
  </svg>
);
